export function currencyFormat(value) {
    value = Number(value.replace(/\,/g, ''));

    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0
    });
        
    return formatter.format(value || 0).replace('$', '');
    
}